import React from "react";
import styled from "styled-components";
import BREAKPOINTS from "../../constants/breakpoints";
import LeagueLinksDropdown from "./LeagueLinksDropdown";
import SeasonLinksDropdown from "./SeasonLinksDropdown";
import WeekLinksDropdown from "./WeekLinksDropdown";

const StyledLeagueLinksLi = styled.li`
  display: none;

  @media (min-width: ${BREAKPOINTS.md}px) {
    display: block;
  }
`;

const NavTopLeagueLinks = () => {
  return (
    <StyledLeagueLinksLi className={"flex-lg"}>
      <ul className={"flex"}>
        <li>
          <LeagueLinksDropdown />
        </li>
        <li>
          <SeasonLinksDropdown />
        </li>
        <li>
          <WeekLinksDropdown />
        </li>
      </ul>
    </StyledLeagueLinksLi>
  );
};

export default NavTopLeagueLinks;
